import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface DatabaseProcessListGridActionCellRendererParams extends ICellRendererParams {
    killProcess: (params: DatabaseProcessListGridActionCellRendererParams) => void;
}

@Component({
    selector: 'process-list-grid-action-cell',
    template:
        `@if (params && params.data) {
  <button type="button"
    class="ace-btn btn-primary btn-danger has-icon grid-action-button"
    (click)="params.killProcess(params)"
    helpTooltip
    helpContentId="database-process-list.kill-process"
    position="bottom">
    <i class="fa fa-trash"></i>
  </button>
}`,
    standalone: false
})
export class DatabaseProcessListGridActionCellRendererComponent implements ICellRendererAngularComp {
    params: DatabaseProcessListGridActionCellRendererParams;

    agInit(params: DatabaseProcessListGridActionCellRendererParams): void {
        this.params = params;
    }

    refresh(): boolean {
        return false; // tells grid to handle refreshing
    }
}
